export default class EnhancedStickyNav {
    constructor() {
        var _a, _b, _c, _d, _e;
        this.enhancedStickyNav = null;
        this.enhancedStickyNavWrapper = null;
        this.contentWrapper = null;
        this.header = null;
        this.helloBar = null;
        this.tabClass = "c-enhanced-sticky-nav__item";
        this.activeAnchorClass = "c-enhanced-sticky-nav__link--active";
        this.sections = [];
        this.observer = null;
        this.currentActiveId = null;
        this.isManualClick = false;
        this.scrollContainer = null;
        this.scrollList = null;
        this.prevButton = null;
        this.nextButton = null;
        this.currentScrollPosition = 0;
        this.maxScrollPosition = 0;
        this.resizeObserver = null;
        this.stickyObserver = null;
        this.resizeTimer = 0;
        this.applyEventListeners = () => {
            if (!this.enhancedStickyNav)
                return;
            const links = this.enhancedStickyNav.querySelectorAll('a');
            links.forEach(link => {
                link.addEventListener('click', (event) => {
                    var _a;
                    this.isManualClick = true;
                    const anchor = event.currentTarget;
                    this.sections.forEach(section => {
                        section.anchor.classList.remove(this.activeAnchorClass);
                    });
                    anchor.classList.add(this.activeAnchorClass);
                    const targetId = (_a = anchor.getAttribute('href')) === null || _a === void 0 ? void 0 : _a.substring(1);
                    if (targetId) {
                        this.currentActiveId = targetId;
                    }
                    const tab = anchor.closest('.c-enhanced-sticky-nav__item');
                    if (tab) {
                        this.scrollActiveTabIntoView(tab);
                    }
                    const targetSelector = anchor.getAttribute('href');
                    if (targetSelector) {
                        const target = document.querySelector(targetSelector);
                        if (target) {
                            this.activateAdditionalFunctionality(target);
                        }
                    }
                    setTimeout(() => {
                        this.isManualClick = false;
                    }, 1000);
                });
                link.addEventListener('focus', (event) => {
                    const focusedLink = event.currentTarget;
                    const tab = focusedLink.closest('.c-enhanced-sticky-nav__item');
                    if (tab) {
                        this.scrollToItem(tab);
                    }
                });
            });
        };
        this.activateAdditionalFunctionality = (target) => {
            if (target.classList.contains('js-filtered-library-block-wrapper')) {
                const block = target.querySelector('.js-filtered-library-block');
                const accordionButton = target.querySelector('.js-toggle');
                if (block && accordionButton && window.getComputedStyle(block).display === 'none') {
                    accordionButton.click();
                }
            }
        };
        this.applyEventListeners = this.applyEventListeners.bind(this);
        this.enhancedStickyNav = document.getElementById('js-enhanced-sticky-nav');
        this.enhancedStickyNavWrapper = document.getElementById('js-enhanced-sticky-nav-wrapper');
        this.contentWrapper = ((_a = this.enhancedStickyNavWrapper) === null || _a === void 0 ? void 0 : _a.parentElement) || null;
        this.helloBar = document.querySelector('.c-hello-bar');
        this.header = document.querySelector('#header');
        this.scrollContainer = ((_b = this.enhancedStickyNav) === null || _b === void 0 ? void 0 : _b.querySelector('.c-enhanced-sticky-nav__scroll-container')) || null;
        this.scrollList = ((_c = this.enhancedStickyNav) === null || _c === void 0 ? void 0 : _c.querySelector('.c-enhanced-sticky-nav__list')) || null;
        this.prevButton = (_d = this.enhancedStickyNav) === null || _d === void 0 ? void 0 : _d.querySelector('.c-enhanced-sticky-nav__arrow--prev');
        this.nextButton = (_e = this.enhancedStickyNav) === null || _e === void 0 ? void 0 : _e.querySelector('.c-enhanced-sticky-nav__arrow--next');
        this.applyEventListeners();
        this.initIntersectionObserver();
        this.initScrollControls();
        this.initObservers();
        setTimeout(() => {
            this.handleResize();
        }, 100);
    }
    initScrollControls() {
        if (!this.scrollContainer || !this.scrollList || !this.prevButton || !this.nextButton)
            return;
        this.prevButton.addEventListener('click', () => {
            this.scrollToPreviousItem();
        });
        this.nextButton.addEventListener('click', () => {
            this.scrollToNextItem();
        });
        this.calculateScrollBoundaries();
        this.updateScrollButtons();
        this.updateGradientVisibility();
    }
    calculateScrollBoundaries() {
        if (!this.scrollContainer || !this.scrollList)
            return;
        const containerWidth = this.scrollContainer.clientWidth;
        const listWidth = this.scrollList.scrollWidth;
        const availableWidth = containerWidth;
        this.maxScrollPosition = Math.max(0, listWidth - availableWidth);
        if (this.currentScrollPosition > this.maxScrollPosition) {
            this.currentScrollPosition = this.maxScrollPosition;
            this.applyTransform();
        }
    }
    applyTransform() {
        if (!this.scrollList)
            return;
        this.scrollList.style.transform = `translateX(-${this.currentScrollPosition}px)`;
        this.scrollList.style.transition = 'transform 0.3s ease';
    }
    initObservers() {
        this.initResizeObserver();
        this.initStickyObserver();
    }
    initResizeObserver() {
        if (!this.enhancedStickyNav)
            return;
        this.resizeObserver = new ResizeObserver((entries) => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = window.setTimeout(() => {
                this.handleResize();
            }, 250);
        });
        this.resizeObserver.observe(this.enhancedStickyNav);
        if (this.scrollContainer) {
            this.resizeObserver.observe(this.scrollContainer);
        }
        this.resizeObserver.observe(document.body);
    }
    initStickyObserver() {
        if (!this.enhancedStickyNavWrapper)
            return;
        const rootMargin = this.calculateStickyRootMargin();
        this.stickyObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const { isIntersecting } = entry;
                const shouldStick = !isIntersecting;
                this.updateStickyState(shouldStick);
            });
        }, {
            root: null,
            rootMargin: rootMargin,
            threshold: [0, 1]
        });
        this.stickyObserver.observe(this.enhancedStickyNavWrapper);
    }
    calculateStickyRootMargin() {
        var _a;
        let topOffset = 0;
        if (this.helloBar && window.getComputedStyle(this.helloBar).display !== 'none') {
            topOffset += this.helloBar.offsetHeight;
        }
        if (this.header) {
            topOffset += this.header.offsetHeight;
        }
        const navHeight = ((_a = this.enhancedStickyNav) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
        topOffset += navHeight;
        return `-${topOffset}px 0px 0px 0px`;
    }
    updateStickyObserver() {
        if (!this.stickyObserver || !this.enhancedStickyNavWrapper)
            return;
        this.stickyObserver.disconnect();
        this.initStickyObserver();
    }
    updateStickyState(shouldStick) {
        var _a, _b, _c;
        if (!this.enhancedStickyNav || !this.enhancedStickyNavWrapper)
            return;
        const isCurrentlySticky = this.enhancedStickyNav.classList.contains('c-enhanced-sticky-nav--stick');
        if (shouldStick === isCurrentlySticky) {
            return;
        }
        if (shouldStick) {
            let topOffset = 0;
            if (this.helloBar && window.getComputedStyle(this.helloBar).display !== 'none') {
                topOffset += this.helloBar.offsetHeight;
            }
            if (this.header) {
                topOffset += this.header.offsetHeight;
            }
            this.enhancedStickyNav.classList.add('c-enhanced-sticky-nav--stick');
            this.enhancedStickyNav.style.top = `${topOffset - 2}px`;
            const isNavFirstEl = ((_b = (_a = this.contentWrapper) === null || _a === void 0 ? void 0 : _a.firstElementChild) === null || _b === void 0 ? void 0 : _b.id) === ((_c = this.enhancedStickyNavWrapper) === null || _c === void 0 ? void 0 : _c.id);
            const helloBarVisible = this.helloBar && window.getComputedStyle(this.helloBar).display !== 'none';
            const shouldPadMainContent = isNavFirstEl && helloBarVisible;
            if (this.contentWrapper) {
                this.contentWrapper.classList.toggle('u-pt-10', shouldPadMainContent);
            }
        }
        else {
            this.enhancedStickyNav.classList.remove('c-enhanced-sticky-nav--stick');
            this.enhancedStickyNav.style.top = '';
            if (this.contentWrapper) {
                this.contentWrapper.classList.remove('u-pt-10');
            }
        }
    }
    scrollNav(distance) {
        if (!this.scrollList)
            return;
        const newPosition = this.currentScrollPosition + distance;
        this.currentScrollPosition = Math.max(0, Math.min(newPosition, this.maxScrollPosition));
        this.applyTransform();
        this.updateScrollButtons();
        this.updateGradientVisibility();
    }
    scrollToNextItem() {
        if (!this.scrollContainer || !this.scrollList)
            return;
        const items = this.scrollList.querySelectorAll('.c-enhanced-sticky-nav__item');
        const containerCenter = this.currentScrollPosition + (this.scrollContainer.clientWidth / 2);
        let targetItem = null;
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const itemCenter = item.offsetLeft + (item.offsetWidth / 2);
            if (itemCenter > containerCenter) {
                targetItem = item;
                break;
            }
        }
        if (!targetItem && items.length > 0) {
            targetItem = items[items.length - 1];
        }
        if (targetItem) {
            this.scrollToItem(targetItem);
        }
    }
    scrollToPreviousItem() {
        if (!this.scrollContainer || !this.scrollList)
            return;
        const items = this.scrollList.querySelectorAll('.c-enhanced-sticky-nav__item');
        const containerCenter = this.currentScrollPosition + (this.scrollContainer.clientWidth / 2);
        let targetItem = null;
        for (let i = items.length - 1; i >= 0; i--) {
            const item = items[i];
            const itemCenter = item.offsetLeft + (item.offsetWidth / 2);
            if (itemCenter < containerCenter) {
                targetItem = item;
                break;
            }
        }
        if (!targetItem && items.length > 0) {
            targetItem = items[0];
        }
        if (targetItem) {
            this.scrollToItem(targetItem);
        }
    }
    scrollToItem(item) {
        if (!this.scrollContainer)
            return;
        const itemCenter = item.offsetLeft + (item.offsetWidth / 2);
        const containerCenter = this.scrollContainer.clientWidth / 2;
        let targetPosition = itemCenter - containerCenter;
        targetPosition = Math.max(0, Math.min(targetPosition, this.maxScrollPosition));
        this.currentScrollPosition = targetPosition;
        this.applyTransform();
        this.updateScrollButtons();
        this.updateGradientVisibility();
    }
    updateScrollButtons() {
        if (!this.scrollContainer || !this.prevButton || !this.nextButton)
            return;
        const needsScroll = this.maxScrollPosition > 0;
        if (needsScroll) {
            const isMobile = window.innerWidth < 768;
            if (isMobile) {
                this.prevButton.classList.remove('u-hidden');
                this.nextButton.classList.remove('u-hidden');
                this.prevButton.removeAttribute('aria-hidden');
                this.nextButton.removeAttribute('aria-hidden');
                this.prevButton.disabled = this.currentScrollPosition <= 0;
                this.nextButton.disabled = this.currentScrollPosition >= this.maxScrollPosition;
            }
            else {
                this.prevButton.classList.add('u-hidden');
                this.nextButton.classList.add('u-hidden');
                this.prevButton.setAttribute('aria-hidden', 'true');
                this.nextButton.setAttribute('aria-hidden', 'true');
            }
        }
        else {
            this.prevButton.classList.add('u-hidden');
            this.nextButton.classList.add('u-hidden');
            this.prevButton.setAttribute('aria-hidden', 'true');
            this.nextButton.setAttribute('aria-hidden', 'true');
        }
    }
    updateGradientVisibility() {
        if (!this.scrollContainer)
            return;
        const isAtStart = this.currentScrollPosition <= 0;
        const isAtEnd = this.currentScrollPosition >= this.maxScrollPosition;
        this.scrollContainer.classList.toggle('c-enhanced-sticky-nav__scroll-container--at-start', isAtStart);
        this.scrollContainer.classList.toggle('c-enhanced-sticky-nav__scroll-container--at-end', isAtEnd);
    }
    handleResize() {
        this.calculateScrollBoundaries();
        this.updateScrollButtons();
        this.updateGradientVisibility();
        if (this.observer) {
            this.observer.disconnect();
            this.createObserver();
            this.startObserving();
        }
        this.updateStickyObserver();
        if (this.currentActiveId) {
            const activeSection = this.sections.find(s => s.id === this.currentActiveId);
            if (activeSection) {
                this.scrollActiveTabIntoView(activeSection.tab);
            }
        }
        const isMobile = window.innerWidth < 768;
        if (!isMobile && this.currentScrollPosition > 0) {
            this.currentScrollPosition = 0;
            this.applyTransform();
        }
    }
    initIntersectionObserver() {
        setTimeout(() => {
            this.getTargetSections();
            if (this.sections.length === 0) {
                console.warn('No target sections found for sticky nav');
                return;
            }
            this.createObserver();
            this.startObserving();
            setTimeout(() => {
                this.updateActiveNav();
            }, 200);
        }, 100);
    }
    getTargetSections() {
        if (!this.enhancedStickyNav)
            return;
        const navAnchors = this.enhancedStickyNav.querySelectorAll('.c-enhanced-sticky-nav__link');
        navAnchors.forEach(anchor => {
            const href = anchor.getAttribute('href');
            if (href && href.startsWith('#')) {
                const targetId = href.substring(1);
                const section = document.getElementById(targetId);
                const tab = anchor.closest('.c-enhanced-sticky-nav__item');
                if (section && tab) {
                    this.sections.push({
                        element: section,
                        id: targetId,
                        anchor: anchor,
                        tab: tab,
                        isVisible: false,
                        intersectionRatio: 0
                    });
                }
            }
        });
    }
    createObserver() {
        var _a;
        const stickyNavHeight = ((_a = this.enhancedStickyNav) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
        const rootMargin = `-${stickyNavHeight + 20}px 0px -60% 0px`;
        const options = {
            root: null,
            rootMargin: rootMargin,
            threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0]
        };
        this.observer = new IntersectionObserver((entries) => {
            this.handleIntersection(entries);
        }, options);
    }
    handleIntersection(entries) {
        if (this.isManualClick)
            return;
        entries.forEach(entry => {
            const section = this.sections.find(s => s.element === entry.target);
            if (section) {
                section.isVisible = entry.isIntersecting;
                section.intersectionRatio = entry.intersectionRatio;
            }
        });
        this.updateActiveNav();
    }
    determineActiveSection() {
        const visibleSections = this.sections.filter(s => s.isVisible);
        if (visibleSections.length === 0) {
            const lastPassedSection = this.findLastPassedSection();
            if (!lastPassedSection) {
                return null;
            }
            return lastPassedSection;
        }
        if (visibleSections.length === 1) {
            return visibleSections[0];
        }
        return visibleSections.reduce((prev, current) => {
            if (current.intersectionRatio > prev.intersectionRatio) {
                return current;
            }
            return prev;
        });
    }
    findLastPassedSection() {
        var _a;
        if (this.sections.length === 0)
            return null;
        const viewportTop = window.pageYOffset || document.documentElement.scrollTop;
        const stickyNavHeight = ((_a = this.enhancedStickyNav) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
        const triggerPoint = viewportTop + stickyNavHeight;
        const passedSections = this.sections.filter(section => {
            return section.element.offsetTop < triggerPoint;
        });
        if (passedSections.length === 0) {
            return null;
        }
        return passedSections.reduce((prev, current) => {
            return current.element.offsetTop > prev.element.offsetTop ? current : prev;
        });
    }
    updateActiveNav() {
        if (this.isManualClick)
            return;
        const activeSection = this.determineActiveSection();
        if (!activeSection && this.currentActiveId) {
            this.sections.forEach(section => {
                section.anchor.classList.remove(this.activeAnchorClass);
            });
            this.currentActiveId = null;
            return;
        }
        if (activeSection && activeSection.id !== this.currentActiveId) {
            this.sections.forEach(section => {
                section.anchor.classList.remove(this.activeAnchorClass);
            });
            activeSection.anchor.classList.add(this.activeAnchorClass);
            this.currentActiveId = activeSection.id;
            this.scrollActiveTabIntoView(activeSection.tab);
        }
    }
    scrollActiveTabIntoView(tab) {
        if (!this.scrollContainer || !this.scrollList)
            return;
        const containerRect = this.scrollContainer.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const isFullyVisible = tabRect.left >= containerRect.left &&
            tabRect.right <= containerRect.right;
        if (!isFullyVisible) {
            const tabCenter = tab.offsetLeft + (tab.offsetWidth / 2);
            const containerCenter = this.scrollContainer.clientWidth / 2;
            let targetPosition = tabCenter - containerCenter;
            targetPosition = Math.max(0, Math.min(targetPosition, this.maxScrollPosition));
            this.currentScrollPosition = targetPosition;
            this.applyTransform();
            this.updateScrollButtons();
            this.updateGradientVisibility();
        }
    }
    startObserving() {
        this.sections.forEach(section => {
            var _a;
            (_a = this.observer) === null || _a === void 0 ? void 0 : _a.observe(section.element);
        });
    }
    destroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
        if (this.stickyObserver) {
            this.stickyObserver.disconnect();
        }
        if (this.enhancedStickyNavWrapper) {
            const placeholder = this.enhancedStickyNavWrapper.querySelector('.enhanced-sticky-nav-placeholder');
            if (placeholder) {
                placeholder.remove();
            }
        }
        if (this.resizeTimer) {
            clearTimeout(this.resizeTimer);
        }
        this.sections.forEach(section => {
            section.anchor.classList.remove(this.activeAnchorClass);
        });
        if (this.scrollContainer) {
            this.scrollContainer.removeEventListener('scroll', () => { });
        }
    }
    static init() {
        const element = document.getElementById('js-enhanced-sticky-nav');
        if (element) {
            const enhancedStickyNav = new EnhancedStickyNav();
            return enhancedStickyNav;
        }
        else {
            return null;
        }
    }
}
